module.exports = __webpack_public_path__ + "static/teradek-7b95a1b0e21c9e76de031707dadb2821.png";